import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import { useScripts } from '../hooks/useScripts';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { getDomain } from '../utils/getDomain';

const HQ_ADDRESS = 'Daalwijkdreef 47, 1103AD Amsterdam';
const HQ_LAT = 52.32695;
const HQ_LNG = 4.97886;
const OSM_BBOX = `${HQ_LNG - 0.003},${HQ_LAT - 0.002},${HQ_LNG + 0.003},${HQ_LAT + 0.002}`;
const OSM_EMBED_URL = `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(OSM_BBOX)}&layer=mapnik&marker=${HQ_LAT}%2C${HQ_LNG}`;

function Contact() {
  const domain = getDomain();
  const contactEmail = `contact@${domain}`;
  
  useDocumentTitle('Contact');
  useScripts();
  
  useEffect(() => {
    // Add contact class to body for proper styling
    document.body.classList.add('contact');
    
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('contact');
    };
  }, []);
  
  return (
    <>
      {/* Contact Info Section */}
      <div className="bg-form">
        <div className="container">
          <h2 className="text-center">Contact Us</h2>
          <p className="text-center">We're here to help.</p>
          <div className="info-block-contact info-block-contact-combined">
            <div className="contact-details">
              <div className="inside">
                <div className="images">
                  <img src="/assets/images/mail-light.svg" alt="mail" />
                </div>
                <h4>Email Us</h4>
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              </div>
              <div className="contact-detail-divider" aria-hidden="true" />
              <div className="inside">
                <div className="images">
                  <img src="/assets/images/address-light.svg" alt="address" />
                </div>
                <h4>Address</h4>
                <span>{HQ_ADDRESS}</span>
              </div>
            </div>
          </div>

          <div className="contact-map-section">
            <h3>Our headquarters</h3>
            <div className="contact-map-wrapper">
              <iframe
                title="Incogninet headquarters on OpenStreetMap"
                src={OSM_EMBED_URL}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Contact;
